import { render, staticRenderFns } from "./ItemField.vue?vue&type=template&id=6246f9c0&scoped=true&"
import script from "./ItemField.vue?vue&type=script&lang=js&"
export * from "./ItemField.vue?vue&type=script&lang=js&"
import style0 from "./ItemField.vue?vue&type=style&index=0&id=6246f9c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6246f9c0",
  null
  
)

export default component.exports